import { render, staticRenderFns } from "./DeleteMember.vue?vue&type=template&id=ce5ac5aa&scoped=true&"
import script from "./DeleteMember.vue?vue&type=script&lang=js&"
export * from "./DeleteMember.vue?vue&type=script&lang=js&"
import style0 from "./DeleteMember.vue?vue&type=style&index=0&id=ce5ac5aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce5ac5aa",
  null
  
)

export default component.exports